
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ComplianceTimelineEventResource,
  ValidationError,
} from '../models';
import {
    ComplianceTimelineEventResourceFromJSON,
    ComplianceTimelineEventResourceToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface RetrieveComplianceTimelineRequest {
    subcontractorCompanyId: string;
}

/**
 * 
 */
export class UmbrellaSearchApi extends runtime.BaseAPI {

    /**
     * Trigger global reindexation of all umbrella companies (admin endpoint)
          */
    async reindexAllUmbrellasRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/compliance/api/umbrella/admin/reindex-all`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Trigger global reindexation of all umbrella companies (admin endpoint)
          */
    async reindexAllUmbrellas(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.reindexAllUmbrellasRaw(initOverrides);
    }

    /**
     * Retrieve compliance timeline for company
          */
    async retrieveComplianceTimelineRaw(requestParameters: RetrieveComplianceTimelineRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<ComplianceTimelineEventResource>>> {
        if (requestParameters['subcontractorCompanyId'] == null) {
            throw new runtime.RequiredError(
                'subcontractorCompanyId',
                'Required parameter "subcontractorCompanyId" was null or undefined when calling retrieveComplianceTimeline().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<ComplianceTimelineEventResource>>({
            path: `/compliance/api/umbrella/admin/{subcontractorCompanyId}/timeline`.replace(`{${"subcontractorCompanyId"}}`, encodeURIComponent(String(requestParameters['subcontractorCompanyId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(ComplianceTimelineEventResourceFromJSON);
        return response;
    }

    /**
     * Retrieve compliance timeline for company
          */
    async retrieveComplianceTimeline(requestParameters: RetrieveComplianceTimelineRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<ComplianceTimelineEventResource>> {
        const response = await this.retrieveComplianceTimelineRaw(requestParameters, initOverrides);
        return response._data;
    }

}
